export default {
  自助零售和游戏游艺: 'Self - service retail and gaming fun',
  自助零售: 'Vending & Retail',
  自助: 'Vending & Retail',
  游戏游艺: 'Games & Amusement',
  泳池Spa和游戏游艺: 'Pool & Spa & Games & Amusement',
  泳池: 'Pool & Spa',
  游艺: 'Game & Amusement',
}
